<template>
  <div class="get-start-page">
    <header class="header">
      <img
        src="../../../assets/logo-text.png"
        alt="OxpeckerLogo"
        class="logo"
      />
    </header>
    <main class="main-content">
      <h1>{{ $t('GetStart.title', { APP_TITLE: APP_TITLE }) }}</h1>
      <p>{{ $t('GetStart.description', { APP_TITLE: APP_TITLE }) }}</p>
      <div class="form-container">
        <!-- <el-tabs
          v-model="activeTab"
          type="card"
          class="tabs"
          @input="handleChange"
        >
          <el-tab-pane
            :label="$t('GetStart.enterprise')"
            name="enterprise"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('GetStart.personal')"
            name="personal"
          ></el-tab-pane>
        </el-tabs> -->
        <el-form
          ref="form"
          :model="form"
          :rules="realRule"
          :validate-on-rule-change="false"
          inline-message
          class="form-content"
        >
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item
                :label="$t('GetStart.firstName')"
                prop="firstName"
              >
                <el-input
                  v-model="form.firstName"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$t('GetStart.lastName')"
                prop="lastName"
              >
                <el-input
                  v-model="form.lastName"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('GetStart.linkedIn')">
                <el-input
                  v-model="form.linkedIn"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item
                :label="$t('GetStart.companyName')"
                prop="company"
              >
                <el-input
                  v-model="form.company"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$t('GetStart.jobTitle')"
                prop="position"
              >
                <el-input
                  v-model="form.position"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('GetStart.twitter')">
                <el-input
                  v-model="form.twitter"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="activeTab == 'personal' ? $t('GetStart.privateEmail') : $t('GetStart.workEmail')"
                prop="email"
              >
                <el-input
                  v-model="form.email"
                  size="mini"
                  :placeholder="$t('GetStart.emailHint')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('GetStart.github')">
                <el-input
                  v-model="form.github"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$t('GetStart.origin')"
                prop="origin"
              >
                <el-select
                  class="how-did-you-hear-select"
                  v-model="form.origin"
                  size="mini"
                  :placeholder="$t('GetStart.originHint')"
                >
                  <el-option
                    v-for="item in originOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  /></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
            </el-col>
          </el-row>

          <el-row
            style="relative"
            :gutter="20"
          >
            <el-col :span="8">
              <el-form-item
                :label="$t('GetStart.applicationAim')"
                prop="purpose"
                required
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 20}"
                  :placeholder="$t('GetStart.purposePlaceholder', { APP_TITLE: APP_TITLE })"
                  v-model="form.purpose"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div
                v-if="activeTab == 'personal'"
                class="personal-text"
              >{{ $t('GetStart.personalText') }}
              </div>
              <el-button
                class="submitBtn"
                type="primary"
                size="mini"
                @click="handleSubmit"
                :loading="loading"
              >{{ hasApply ? $t('GetStart.modify') :  $t('GetStart.submit') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
import { getAccessRequest } from '@/api/base';
import { getApplyInfo } from '@/api/base';
import { mapGetters, mapActions } from 'vuex';
import { getOriginList } from '@/api/base';

export default {
  name: 'GetStart',
  data() {
    return {
      activeTab: 'enterprise',
      loading: false,
      form: {
        firstName: '',
        lastName: '',
        company: '',
        position: '',
        email: '',
        purpose: '',
        linkedIn: '',
        twitter: '',
        github: '',
        origin: '',
      },
      originOptions: [],
    };
  },
  computed: {
    ...mapGetters('user', ['applyInfo']),
    realRule() {
      const rules = {
        firstName: [{ required: true, message: this.$t('GetStart.firstNameRequired'), trigger: 'blur' }],
        lastName: [{ required: true, message: this.$t('GetStart.lastNameRequired'), trigger: 'blur' }],
        company: [{ required: true, message: this.$t('GetStart.companyRequired'), trigger: 'blur' }],
        position: [{ required: true, message: this.$t('GetStart.positionRequired'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('GetStart.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('GetStart.emailInvalid'), trigger: ['blur', 'change'] },
        ],
        purpose: [{ required: true, message: this.$t('GetStart.purposeRequired'), trigger: 'blur' }],
      };

      if (this.activeTab === 'personal') {
        // Remove company and position from required fields for personal users
        const personalRules = { ...rules };
        delete personalRules.company;
        delete personalRules.position;
        return personalRules;
      }

      return rules;
    },
    hasApply() {
      return Boolean(this.applyInfo);
    },
  },
  watch: {
    applyInfo: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.form.firstName = newValue.firstName;
          this.form.lastName = newValue.lastName;
          this.form.company = newValue.company;
          this.form.position = newValue.position;
          this.form.email = newValue.email;
          this.form.purpose = newValue.purpose;
          this.form.linkedIn = newValue.linkedIn;
          this.form.twitter = newValue.twitter;
          this.form.github = newValue.github;
        }
      },
    },
  },
  created() {
    if (this.applyInfo) {
      this.getApplyInfo();
    }
    this.getOrigin();
  },
  methods: {
    ...mapActions('user', ['setApplyInfo']),
    getApplyInfo() {
      getApplyInfo().then((res) => {
        this.setApplyInfo(res);
      });
    },
    handleChange() {
      this.$refs.form.clearValidate();
    },
    handleSubmit() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      this.$refs.form.validate((valid) => {
        if (valid) {
          getAccessRequest({ ...this.form, accountType: this.activeTab })
            .then((res) => {
              console.log(res);
              this.$router.push('/submit-request');
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log('error submit!!');
          this.loading = false;
          return false;
        }
      });
    },
    getOriginList() {
      getOriginList().then((res) => {
        console.log(res);
      });
    },
    getOrigin() {
      getOriginList().then((res) => {
        if (res && res.origins) {
          this.originOptions = res.origins.map((origin) => ({
            value: origin,
            label: origin,
          }));
        }
      });
    },
  },
};
</script>

<style lang="scss">
.get-start-page {
  width: 100%;
  height: calc(100vh - 20px);

  .form-container {
    margin-top: 40px;
  }

  .how-did-you-hear-select {
    width: 100%;
  }

  & .submitBtn {
    position: absolute !important;
    top: 148px;
    width: 200px;
    left: 46%;
    transform: translateX(-50%);
    font-size: 16px;
  }

  .get-start-page .el-tabs {
    margin-bottom: 0px;
    width: 35%;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item__label {
    line-height: 30px;
  }

  .el-textarea__inner {
    height: 150px !important;
  }

  .el-tabs {
    width: 30%;
  }

  .el-tabs__item.is-active {
    color: #ffffff;
    background-color: #000000;
  }

  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }

  .header {
    display: flex;
    justify-content: left;
    background-color: #ffffff;
    width: 95%;
    border-radius: 5px;
    padding: 10px 40px;
    margin: 0px 10px;
  }

  .logo {
    width: 200px;
  }

  .main-content {
    margin: 10px auto;
    background: #ffffff;
    width: 95%;
    border-radius: 5px;
    padding: 20px 40px;
    height: calc(100vh - 145px);
  }

  .main-content h1 {
    text-align: left;
  }

  .form-content {
    margin-top: -20px;
  }

  .email-hint {
    display: block;
    color: #999;
    font-size: 12px;
    margin-top: 5px;
  }

  .el-tabs {
    margin-bottom: 20px;
  }

  h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    position: absolute;
    left: 38.5rem;
    top: -4rem;
  }

  .submit {
    background-color: #2b2b2b;
    color: #ffffff;
    border: 2px solid #2b2b2b;
    border-radius: 5px;
    margin: 0px 30px;
    width: 20%;
    height: 30px;
    line-height: 5px;
    font-size: 17px;
  }
  .submits {
    background-color: #2b2b2b;
    color: #ffffff;
    border: 2px solid #2b2b2b;
    border-radius: 5px;
    margin: 150px 30px;
    width: 20%;
    height: 30px;
    line-height: 5px;
    font-size: 17px;
  }

  .personal-text {
    font-size: 12px;
    margin: 40px 30px;
    color: #000000;
    width: 255px;
  }
}
</style>